import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../AssetHelpers'
type Props = {
  className?: string
  path: string
  svgClassName?: string,
  styles?: any
}

const KTSVG: React.FC<Props> = ({className = '', path, svgClassName = 'mh-50px', styles}) => {
  return (
    <span className={`svg-icon ${className}`} style={{...styles}}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  )
}

export {KTSVG}
